import React, { useState, useEffect } from 'react';
import { Typography, Box, TextField, Button, Select, MenuItem, Autocomplete, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import TokenService from "../../services/security/token.service";
import fix from "../../services/fix";
import informationService from '../../services/system';
import orderFix from "../../services/orderSingleFix"
import TimedAlert from "../../components/TimedAlert";
import CircularProgress from '@mui/material/CircularProgress';
import constants from '../../utils/constants';

const securityType = ["CS", "OPT", "CD", "GO", "CORP", "QS", "FUT"];

const FooterOperaciones = ({ selectSymbol, onSelectSymbolChange }) => {

    const user = TokenService.getUser();
    const [plazo, setPlazo] = useState('2');
    const [autocompleteValue, setAutocompleteValue] = useState(selectSymbol);
    const [opcionesEspecies, setOpcionesEspecies] = useState([]);
    const [cantidad, setCantidad] = useState('');
    const [precio, setPrecio] = useState('');
    const [importe, setImporte] = useState('');
    const [validez, setValidez] = useState(new Date().toISOString().split('T')[0]);
    const [alertSendOrder, setAlertSendOrder] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loadAutocomplete, setLoadAutocomplete] = useState(false);
    const [openConfirm, setOpenConfirm] = useState(false);
    const [side, setSide] = useState(null);
    const [validation, setValidation] = useState(null);
    const [qtyHolding, setQtyHolding] = useState(0);
    const [amountBalance, setAmountBalance] = useState(0);



    const handleClickOpen = (sideValue) => {


        //if (precio && cantidad && autocompleteValue && validez && importe && plazo) {
        if (precio && cantidad && validez && importe && plazo) {

            let diasPlazo = Number(plazo) - 1;
            let dateParam = new Date();
            dateParam.setDate(dateParam.getDate() + diasPlazo);
            let dateParam1 = formatDateParam(dateParam);

            let entityPropertyIdParam = user.data.entityPropertyId;
            let paymentSystemIdParamFlag = null;
            if (autocompleteValue !== null) {
                paymentSystemIdParamFlag = autocompleteValue.securityID?.split('-').pop() ?? null;
            }

            const paymentSystems = {
                ARS: 1,
                USD: 2,
                EXT: 3
            };

            let paymentSystemIdParam = paymentSystems[paymentSystemIdParamFlag] ?? 99999;
            if (sideValue === '1') {//compra
                informationService.storeProcedureEntityBalanceAvailableAsOf('entityBalanceAvailableAsOf', user.data.instance, dateParam1, entityPropertyIdParam, paymentSystemIdParam).then((response) => {
                    const resp = response.data;
                    if (resp.length > 0) {
                        let amountBalance = Number(resp[0].amountBalance);
                        setAmountBalance(amountBalance);
                        if (Number(amountBalance) < Number(importe)) {
                            setValidation('No hay saldo disponible para realizar la operación');
                        } else {
                            setValidation(null);
                        }
                    } else {
                        setValidation('No hay saldo disponible para realizar la operación');
                        setAmountBalance(0);
                    }
                    setSide(sideValue);
                    setOpenConfirm(true);
                });
            }
            if (sideValue === '2') {//venta

                let itemPropertyIdParam = 998878;
                if (autocompleteValue !== null) {
                    itemPropertyIdParam = autocompleteValue.label;
                }
                informationService.storeProcedureEntityHoldingAvailableAsOf('entityHoldingAvailableAsOf', user.data.instance, dateParam1, entityPropertyIdParam, itemPropertyIdParam).then((response) => {
                    const resp = response.data;
                    if (resp.length > 0) {
                        let qtyHolding = Number(resp[0].qtyHolding);
                        setQtyHolding(qtyHolding);
                        if (Number(qtyHolding) < Number(cantidad)) {
                            setValidation('No hay saldo disponible para realizar la operación');
                        } else {
                            setValidation(null);
                        }
                    } else {
                        setValidation('No hay saldo disponible para realizar la operación');
                        setQtyHolding(0);
                    }
                    setSide(sideValue);
                    setOpenConfirm(true);
                });
            }
        } else {
            setAlertSendOrder({ code: 'error', description: 'Complete todos los campos' })
        }
    };

    const handleClose = () => {
        setOpenConfirm(false);
        setSide(null);
    };

    const handleConfirm = () => {
        if (side)
            sendOrder(side);
        setOpenConfirm(false);
    };

    const formatDateParam = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }


    const formatDate = (date) => {
        console.log("date-> " + date);

        if (!date) return "";

        const [year, month, day] = date.split("-");

        const formatted = `${day}-${month}-${year}`;

        return formatted;
    };
    const formattedValidez = formatDate(validez);

    async function fetchPrice(type, startIndex = 0) {
        const responseData = await fix.prices(type);
        let arrayResponse = [];
        let index = startIndex;
        for (let t = 0; t < responseData.data.length; t++) {
            for (let a = 0; a < responseData.data[t].subTabs.length; a++) {
                for (let b = 0; b < responseData.data[t].subTabs[a].especies.length; b++) {

                    let settlType = 1;
                    if (responseData.data[t].subTabs[a].especies[b].NoMDEntries.length > 0) {
                        settlType = responseData.data[t].subTabs[a].especies[b].NoMDEntries[0].SettlType;
                    }
                    arrayResponse.push({
                        id: index,
                        label: responseData.data[t].subTabs[a].especies[b].Symbol,
                        securityType: responseData.data[t].subTabs[a].especies[b].SecurityType,
                        securityID: responseData.data[t].subTabs[a].especies[b].SecurityID,
                        settlType: settlType
                    });
                    index++;
                }
            }
        }

        const uniqueArray = Array.from(
            new Map(arrayResponse.map(item => [item.label, item])).values()
        );

        return { array: uniqueArray, nextIndex: index };
    }

    useEffect(() => {
        setAutocompleteValue(selectSymbol);
    }, [selectSymbol]);

    useEffect(() => {
        if (user.data.isTrader === '1') {
            let arrayResponse = [];
            let globalIndex = 0; // contador global

            const fetchAll = async () => {
                for (let d = 0; d < securityType.length; d++) {
                    const result = await fetchPrice(securityType[d], globalIndex);
                    arrayResponse = arrayResponse.concat(result.array);
                    globalIndex = result.nextIndex; // actualiza el contador
                }
                setOpcionesEspecies(arrayResponse);
                setLoadAutocomplete(true);
            };
            fetchAll();


        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const opcionesPlazos = [
        { value: '1', label: 'C.I.' },
        { value: '2', label: '24 Hs.' },
    ];

    const handleLimpiar = () => {
        setPlazo('');
        setAutocompleteValue(null);
        setCantidad('');
        setPrecio('');
        setImporte('');
        setValidez('');
    };

    const generateNumber = () => {
        const numeros = '0123456789';
        const nuevoValor = [];

        for (let i = 0; i < 3; i++) {
            nuevoValor.push(numeros[Math.floor(Math.random() * numeros.length)]);
        }

        return nuevoValor.join('');
    };

    const sendOrder = (side) => {

        setAlertSendOrder(null);
        setLoading(true);


        let clOrdID = generateNumber();
        const now = new Date();

        const pad = (num, size = 2) => String(num).padStart(size, "0");

        const transactTime =
            `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}-` +
            `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}.${pad(now.getMilliseconds(), 3)}`;

        const vali = validez.split('-');
        const settlDate = `${vali[0]}${vali[1]}${vali[2]}`;

        const today = new Date();
        const todayStr =
            today.getFullYear() +
            String(today.getMonth() + 1).padStart(2, "0") +
            String(today.getDate()).padStart(2, "0");

        const isToday = settlDate === todayStr;

        let request = {
            "clOrdID": clOrdID,//11
            "noPartyIDs": "1",//453
            "partyID": "dmx220-3",//448
            "partyIDSource": "D",//447
            "partyRole": "53",//452
            "account": "220",//1
            "symbol": autocompleteValue.label,//55
            "securityType": autocompleteValue.securityType,//167
            "currency": "ARS",//15
            "ordType": "2", //limit //40
            "side": side, //compra venta //54
            "orderQty": cantidad,//38
            "price": precio,//44
            "transactTime": transactTime,//60
            "settlType": plazo, //63
            "settlDate": settlDate,//64
            "tradeFlag": "1",//29501
            "securityID": autocompleteValue.securityID,//48
            timeInForce: isToday ? "0" : "6", //59
            ...(isToday ? {} : { expireDate: settlDate }) //432
        }

        console.log('request-> ' + JSON.stringify(request))
        orderFix.save(constants.CLIENT, user.data.instance, request).then((response) => {

        })

        setTimeout(() => {
            setAlertSendOrder({ code: 'success', description: 'La órden fue ingresada.' })
            setLoading(false);
        }, 3000);

    }

    const setImporteAutomatico = (precio, cantidad) => {
        if (!precio)
            precio = 0
        if (!cantidad)
            cantidad = 0
        let imp = precio * cantidad;
        setImporte(imp.toFixed(2))

    }

    return (
        <>

            {user.data.isTrader === '1' && (
                <Box
                    sx={{
                        position: 'fixed',
                        bottom: 0,
                        left: 0,
                        width: '100%',
                        bgcolor: 'background.paper',
                        boxShadow: '0 -2px 8px rgba(0,0,0,0.1)',
                        p: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 2,
                        zIndex: 1000,
                        fontSize: "inherit",
                        fontWeight: 500,
                        lineHeight: "inherit",
                    }}
                >
                    <Autocomplete
                        sx={{
                            width: 250,
                            "& .MuiInputBase-root": {
                                fontSize: "0.65rem",
                                fontWeight: 500,
                                lineHeight: "inherit",
                            },
                            "& .MuiInputLabel-root": {
                                fontSize: "0.65rem",
                            },

                        }}
                        slotProps={{
                            paper: {
                                sx: {
                                    "& .MuiAutocomplete-listbox": {
                                        fontSize: "0.65rem",
                                        fontWeight: 500,
                                        lineHeight: "inherit",
                                    },
                                    "& .MuiAutocomplete-option": {
                                        fontSize: "0.65rem",
                                        fontWeight: 500,
                                        lineHeight: "inherit",
                                    },
                                },
                            },
                        }}
                        disabled={loadAutocomplete === false ? true : false}
                        options={opcionesEspecies}
                        value={autocompleteValue}
                        onChange={(e, newValue) => {
                            setAutocompleteValue(newValue)
                            onSelectSymbolChange?.(newValue);
                        }
                        }
                        isOptionEqualToValue={(option, value) => option.securityID === value.securityID}
                        renderInput={(params) => <TextField {...params} label={`Especie ${loadAutocomplete === false ? '(Cargando...)' : ''}`} size="small" />}
                    />

                    <Select
                        value={plazo}
                        onChange={(e) => setPlazo(e.target.value)}
                        displayEmpty
                        size="small"
                        sx={{
                            width: 120,
                            "& .MuiSelect-select": {
                                fontSize: "0.65rem",
                                fontWeight: 500,
                                lineHeight: "inherit",
                                paddingY: "6px",
                            },
                            "& .MuiInputBase-root": {
                                fontSize: "0.65rem",
                                fontWeight: 500,
                                lineHeight: "inherit"
                            },
                        }}
                    >
                        {opcionesPlazos.map((op) => (
                            <MenuItem key={op.value} value={op.value} sx={{
                                fontSize: "0.65rem",
                                fontWeight: 500,
                                lineHeight: "inherit"
                            }}>
                                {op.label}
                            </MenuItem>
                        ))}
                    </Select>

                    <TextField
                        label="Cantidad"
                        type="number"
                        size="small"
                        value={cantidad}
                        onChange={(e) => {
                            setCantidad(e.target.value)
                            setImporteAutomatico(precio, e.target.value);
                        }
                        }
                        sx={{
                            width: 150,
                            "& .MuiInputBase-root": {
                                fontSize: "inherit",
                                fontWeight: 500,
                                lineHeight: "inherit",
                                fontVariantNumeric: 'tabular-nums'
                            },
                            "& .MuiInputLabel-root": {
                                fontSize: "inherit",
                                fontVariantNumeric: 'tabular-nums'
                            },
                        }}
                    />

                    <TextField
                        label="Precio"
                        type="number"
                        size="small"
                        value={precio}
                        onChange={(e) => {
                            setPrecio(e.target.value)
                            setImporteAutomatico(e.target.value, cantidad);
                        }
                        }
                        sx={{
                            width: 150,
                            "& .MuiInputBase-root": {
                                fontSize: "inherit",
                                fontWeight: 500,
                                lineHeight: "inherit",
                                fontVariantNumeric: 'tabular-nums'

                            },
                            "& .MuiInputLabel-root": {
                                fontSize: "inherit",
                                fontVariantNumeric: 'tabular-nums'

                            },
                        }}
                    />

                    <TextField
                        label="Importe"
                        type="number"
                        size="small"
                        value={importe}
                        onChange={(e) => setImporte(e.target.value)}
                        sx={{
                            width: 150,
                            "& .MuiInputBase-root": {
                                fontSize: "inherit",
                                fontWeight: 500,
                                lineHeight: "inherit",
                                fontVariantNumeric: 'tabular-nums'

                            },
                            "& .MuiInputLabel-root": {
                                fontSize: "inherit",
                                fontVariantNumeric: 'tabular-nums'

                            },
                        }}
                    />

                    <TextField
                        label="Validez"
                        type="date"
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        value={validez}
                        onChange={(e) => setValidez(e.target.value)}
                        sx={{
                            width: 150,
                            "& .MuiInputBase-root": {
                                fontSize: "inherit",
                                fontWeight: 500,
                                lineHeight: "inherit"
                            },
                            "& .MuiInputLabel-root": {
                                fontSize: "inherit",
                            },
                        }}
                    />

                    <Box sx={{ display: 'flex', gap: 1 }}>
                        {loading === false && (
                            <>
                                <Button
                                    variant="contained"
                                    sx={{
                                        backgroundColor: '#2e7d32',
                                        fontSize: '10px',
                                        color: '#fff',
                                        '&:hover': { backgroundColor: '#1b5e20' },
                                    }}
                                    onClick={() => handleClickOpen("1")}
                                >
                                    Comprar
                                </Button>
                                <Button
                                    variant="contained"
                                    sx={{
                                        backgroundColor: '#c62828',
                                        fontSize: '10px',
                                        color: '#fff',
                                        '&:hover': { backgroundColor: '#8e0000' },
                                    }}
                                    onClick={() => handleClickOpen("2")}
                                >
                                    Vender
                                </Button>
                                <Button variant="outlined" color="secondary" onClick={handleLimpiar} sx={{ fontSize: '10px' }}>
                                    Limpiar
                                </Button>
                            </>
                        )}
                        {loading === true && (<CircularProgress size={20} />)}
                        {alertSendOrder && (
                            <TimedAlert message={alertSendOrder.description} duration={5000} type={alertSendOrder.code} />
                        )}

                        <Dialog
                            open={openConfirm}
                            onClose={handleClose}
                        >
                            <DialogTitle>
                                {validation
                                    ? 'ADVERTENCIA'
                                    : `Confirmar orden de ${side === '1' ? 'Compra' : 'Venta'}`
                                }
                            </DialogTitle>
                            <DialogContent>
                                <DialogContentText sx={{ mb: 1 }}>
                                    {validation
                                        ? validation
                                        : 'A continuación se muestran los datos de la orden:'}
                                </DialogContentText>

                                <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                    {validation && (
                                        <Typography variant="body2">
                                            Saldo Disponible: {side === '1' ? amountBalance : qtyHolding}
                                        </Typography>
                                    )}
                                    <Typography variant="body2">Especie: {autocompleteValue ? autocompleteValue.label : ""}</Typography>
                                    <Typography variant="body2">Plazo: {plazo === '1' ? 'C.I.' : '24 Hs.'}</Typography>
                                    <Typography variant="body2">Cantidad: {cantidad}</Typography>
                                    <Typography variant="body2">Precio: {precio}</Typography>
                                    <Typography variant="body2">Importe: {importe}</Typography>
                                    <Typography variant="body2">Validez: {formattedValidez}</Typography>
                                </div>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handleClose} >
                                    Cancelar
                                </Button>
                                {validation === null && (<Button onClick={handleConfirm}>
                                    Confirmar
                                </Button>)}
                            </DialogActions>
                        </Dialog>
                    </Box>
                </Box>
            )}
        </>
    );
};

export default FooterOperaciones;